/**
 * The original's keyboard command tree.
 *
 * GENERATED by tools/extract-menus.ts from OG2.h — do not edit by hand.
 *
 * CIRCAD is keyboard-driven: a menu letter then a command letter. `F` `O`
 * opens a file, `N` `R` builds the ratsnest. `symbol` is the original
 * #define, so any command here can be traced back into the C source.
 *
 * Presence here means the original had the command, not that SirCAD implements
 * it — see MenuCommand.implemented in the menu runtime.
 */

export interface MenuCommand {
  /** Two-key code, e.g. "NR". */
  code: string;
  /** Menu letter. */
  menu: string;
  /** Command letter within the menu. */
  key: string;
  /** The original's #define name. */
  symbol: string;
  label: string;
}

export interface Menu {
  key: string;
  label: string;
  commands: MenuCommand[];
}

export const MENUS: Menu[] = [
 {
  "key": "F",
  "label": "File",
  "commands": [
   {
    "code": "F?",
    "menu": "F",
    "key": "?",
    "symbol": "File_ReOpen_Clear",
    "label": "Re Open Clear"
   },
   {
    "code": "F>",
    "menu": "F",
    "key": ">",
    "symbol": "File_ReOpen_Purge",
    "label": "Re Open Purge"
   },
   {
    "code": "F0",
    "menu": "F",
    "key": "0",
    "symbol": "File_ReOpen_0",
    "label": "Re Open 0"
   },
   {
    "code": "F1",
    "menu": "F",
    "key": "1",
    "symbol": "File_ReOpen_1",
    "label": "Re Open 1"
   },
   {
    "code": "F2",
    "menu": "F",
    "key": "2",
    "symbol": "File_ReOpen_2",
    "label": "Re Open 2"
   },
   {
    "code": "F3",
    "menu": "F",
    "key": "3",
    "symbol": "File_ReOpen_3",
    "label": "Re Open 3"
   },
   {
    "code": "F4",
    "menu": "F",
    "key": "4",
    "symbol": "File_ReOpen_4",
    "label": "Re Open 4"
   },
   {
    "code": "F5",
    "menu": "F",
    "key": "5",
    "symbol": "File_ReOpen_5",
    "label": "Re Open 5"
   },
   {
    "code": "F6",
    "menu": "F",
    "key": "6",
    "symbol": "File_ReOpen_6",
    "label": "Re Open 6"
   },
   {
    "code": "F7",
    "menu": "F",
    "key": "7",
    "symbol": "File_ReOpen_7",
    "label": "Re Open 7"
   },
   {
    "code": "F8",
    "menu": "F",
    "key": "8",
    "symbol": "File_ReOpen_8",
    "label": "Re Open 8"
   },
   {
    "code": "F9",
    "menu": "F",
    "key": "9",
    "symbol": "File_ReOpen_9",
    "label": "Re Open 9"
   },
   {
    "code": "FA",
    "menu": "F",
    "key": "A",
    "symbol": "File_SaveAs",
    "label": "Save As"
   },
   {
    "code": "FB",
    "menu": "F",
    "key": "B",
    "symbol": "File_BomOut",
    "label": "BOM Out"
   },
   {
    "code": "FC",
    "menu": "F",
    "key": "C",
    "symbol": "File_Close",
    "label": "Close"
   },
   {
    "code": "FD",
    "menu": "F",
    "key": "D",
    "symbol": "File_Load",
    "label": "Load"
   },
   {
    "code": "FE",
    "menu": "F",
    "key": "E",
    "symbol": "File_Erase",
    "label": "Erase"
   },
   {
    "code": "FF",
    "menu": "F",
    "key": "F",
    "symbol": "File_SaveAll",
    "label": "Save All"
   },
   {
    "code": "Fg",
    "menu": "F",
    "key": "g",
    "symbol": "File_New_Graphics",
    "label": "New Graphics"
   },
   {
    "code": "FG",
    "menu": "F",
    "key": "G",
    "symbol": "File_GerberOut",
    "label": "Gerber Out"
   },
   {
    "code": "Fi",
    "menu": "F",
    "key": "i",
    "symbol": "File_New_Sibling",
    "label": "New Sibling"
   },
   {
    "code": "FL",
    "menu": "F",
    "key": "L",
    "symbol": "File_Select",
    "label": "Select"
   },
   {
    "code": "FM",
    "menu": "F",
    "key": "M",
    "symbol": "File_Image_Save",
    "label": "Image Save"
   },
   {
    "code": "FN",
    "menu": "F",
    "key": "N",
    "symbol": "File_Next",
    "label": "Next"
   },
   {
    "code": "FO",
    "menu": "F",
    "key": "O",
    "symbol": "File_Open",
    "label": "Open"
   },
   {
    "code": "FP",
    "menu": "F",
    "key": "P",
    "symbol": "File_Print",
    "label": "Print"
   },
   {
    "code": "FQ",
    "menu": "F",
    "key": "Q",
    "symbol": "File_Quit",
    "label": "Quit"
   },
   {
    "code": "Fr",
    "menu": "F",
    "key": "r",
    "symbol": "File_BomIn",
    "label": "BOM In"
   },
   {
    "code": "Fs",
    "menu": "F",
    "key": "s",
    "symbol": "File_New_Slave",
    "label": "New Slave"
   },
   {
    "code": "FS",
    "menu": "F",
    "key": "S",
    "symbol": "File_Save",
    "label": "Save"
   },
   {
    "code": "Ft",
    "menu": "F",
    "key": "t",
    "symbol": "File_New_Text",
    "label": "New Text"
   },
   {
    "code": "FT",
    "menu": "F",
    "key": "T",
    "symbol": "File_ReCall",
    "label": "Recall"
   },
   {
    "code": "Fu",
    "menu": "F",
    "key": "u",
    "symbol": "File_New_Cousin",
    "label": "New Cousin"
   },
   {
    "code": "FU",
    "menu": "F",
    "key": "U",
    "symbol": "File_ShutDown",
    "label": "Shut Down"
   },
   {
    "code": "FV",
    "menu": "F",
    "key": "V",
    "symbol": "File_Prev",
    "label": "Prev"
   },
   {
    "code": "FX",
    "menu": "F",
    "key": "X",
    "symbol": "File_Exit",
    "label": "Exit"
   }
  ]
 },
 {
  "key": "P",
  "label": "Place",
  "commands": [
   {
    "code": "P-",
    "menu": "P",
    "key": "-",
    "symbol": "Place_Ratline",
    "label": "Ratline"
   },
   {
    "code": "P+",
    "menu": "P",
    "key": "+",
    "symbol": "Place_PowerPort",
    "label": "Power Port"
   },
   {
    "code": "PA",
    "menu": "P",
    "key": "A",
    "symbol": "Place_Arc",
    "label": "Arc"
   },
   {
    "code": "PB",
    "menu": "P",
    "key": "B",
    "symbol": "Place_BusPort",
    "label": "Bus Port"
   },
   {
    "code": "PC",
    "menu": "P",
    "key": "C",
    "symbol": "Place_Component",
    "label": "Component"
   },
   {
    "code": "PD",
    "menu": "P",
    "key": "D",
    "symbol": "Place_SignalDot",
    "label": "Signal Dot"
   },
   {
    "code": "PE",
    "menu": "P",
    "key": "E",
    "symbol": "Place_Vertex",
    "label": "Vertex"
   },
   {
    "code": "PF",
    "menu": "P",
    "key": "F",
    "symbol": "Place_FilledSolid",
    "label": "Filled Solid"
   },
   {
    "code": "PG",
    "menu": "P",
    "key": "G",
    "symbol": "Place_SignalGND",
    "label": "Signal GND"
   },
   {
    "code": "PH",
    "menu": "P",
    "key": "H",
    "symbol": "Place_EarthGND",
    "label": "Earth GND"
   },
   {
    "code": "PI",
    "menu": "P",
    "key": "I",
    "symbol": "Place_BusWire",
    "label": "Bus Wire"
   },
   {
    "code": "PJ",
    "menu": "P",
    "key": "J",
    "symbol": "Place_Spiral",
    "label": "Spiral"
   },
   {
    "code": "PK",
    "menu": "P",
    "key": "K",
    "symbol": "Place_PickComponent",
    "label": "Pick Component"
   },
   {
    "code": "PL",
    "menu": "P",
    "key": "L",
    "symbol": "Place_Line",
    "label": "Line"
   },
   {
    "code": "PM",
    "menu": "P",
    "key": "M",
    "symbol": "Place_NamedGND",
    "label": "Named GND"
   },
   {
    "code": "PN",
    "menu": "P",
    "key": "N",
    "symbol": "Place_SignalName",
    "label": "Signal Name"
   },
   {
    "code": "PO",
    "menu": "P",
    "key": "O",
    "symbol": "Place_OrthoLine",
    "label": "Ortho Line"
   },
   {
    "code": "PP",
    "menu": "P",
    "key": "P",
    "symbol": "Place_Pad",
    "label": "Pad"
   },
   {
    "code": "PR",
    "menu": "P",
    "key": "R",
    "symbol": "Place_ArrowHead",
    "label": "Arrow Head"
   },
   {
    "code": "PS",
    "menu": "P",
    "key": "S",
    "symbol": "Place_SignalPort",
    "label": "Signal Port"
   },
   {
    "code": "PT",
    "menu": "P",
    "key": "T",
    "symbol": "Place_Text",
    "label": "Text"
   },
   {
    "code": "PU",
    "menu": "P",
    "key": "U",
    "symbol": "Place_BuildComponent",
    "label": "Build Component"
   },
   {
    "code": "PV",
    "menu": "P",
    "key": "V",
    "symbol": "Place_Via",
    "label": "Via"
   },
   {
    "code": "PW",
    "menu": "P",
    "key": "W",
    "symbol": "Place_SignalWire",
    "label": "Signal Wire"
   },
   {
    "code": "PX",
    "menu": "P",
    "key": "X",
    "symbol": "Place_Dimension",
    "label": "Dimension"
   },
   {
    "code": "PY",
    "menu": "P",
    "key": "Y",
    "symbol": "Place_ArcPoints",
    "label": "Arc Points"
   },
   {
    "code": "PZ",
    "menu": "P",
    "key": "Z",
    "symbol": "Place_SpiralPoints",
    "label": "Spiral Points"
   }
  ]
 },
 {
  "key": "G",
  "label": "Grab",
  "commands": [
   {
    "code": "GA",
    "menu": "G",
    "key": "A",
    "symbol": "Grab_ArcEdge",
    "label": "Arc Edge"
   },
   {
    "code": "GC",
    "menu": "G",
    "key": "C",
    "symbol": "Grab_Component",
    "label": "Component"
   },
   {
    "code": "GD",
    "menu": "G",
    "key": "D",
    "symbol": "Grab_ArcEndPoint",
    "label": "Arc End Point"
   },
   {
    "code": "GE",
    "menu": "G",
    "key": "E",
    "symbol": "Grab_Vertex",
    "label": "Vertex"
   },
   {
    "code": "GF",
    "menu": "G",
    "key": "F",
    "symbol": "Grab_FilledSolid",
    "label": "Filled Solid"
   },
   {
    "code": "GG",
    "menu": "G",
    "key": "G",
    "symbol": "Grab_ArcOrigin",
    "label": "Arc Origin"
   },
   {
    "code": "GI",
    "menu": "G",
    "key": "I",
    "symbol": "Grab_Item",
    "label": "Item"
   },
   {
    "code": "GL",
    "menu": "G",
    "key": "L",
    "symbol": "Grab_Line",
    "label": "Line"
   },
   {
    "code": "GM",
    "menu": "G",
    "key": "M",
    "symbol": "Grab_MirrorTB",
    "label": "Mirror TB"
   },
   {
    "code": "GN",
    "menu": "G",
    "key": "N",
    "symbol": "Grab_RotateN",
    "label": "Rotate N"
   },
   {
    "code": "GO",
    "menu": "G",
    "key": "O",
    "symbol": "Grab_CompOnly",
    "label": "Comp Only"
   },
   {
    "code": "GP",
    "menu": "G",
    "key": "P",
    "symbol": "Grab_Pad",
    "label": "Pad"
   },
   {
    "code": "GR",
    "menu": "G",
    "key": "R",
    "symbol": "Grab_Rotate90",
    "label": "Rotate90"
   },
   {
    "code": "GS",
    "menu": "G",
    "key": "S",
    "symbol": "Grab_ScaleXY",
    "label": "Scale XY"
   },
   {
    "code": "GT",
    "menu": "G",
    "key": "T",
    "symbol": "Grab_Text",
    "label": "Text"
   },
   {
    "code": "GV",
    "menu": "G",
    "key": "V",
    "symbol": "Grab_CurveCenter",
    "label": "Curve Center"
   },
   {
    "code": "GX",
    "menu": "G",
    "key": "X",
    "symbol": "Grab_MirrorX",
    "label": "Mirror X"
   },
   {
    "code": "GY",
    "menu": "G",
    "key": "Y",
    "symbol": "Grab_MirrorY",
    "label": "Mirror Y"
   }
  ]
 },
 {
  "key": "E",
  "label": "Edit",
  "commands": [
   {
    "code": "E-",
    "menu": "E",
    "key": "-",
    "symbol": "Edit_Pix_Convolution_Dilation",
    "label": "Pix Convolution Dilation"
   },
   {
    "code": "E,",
    "menu": "E",
    "key": ",",
    "symbol": "Edit_Pix_Convolution_Erosion",
    "label": "Pix Convolution Erosion"
   },
   {
    "code": "E;",
    "menu": "E",
    "key": ";",
    "symbol": "Edit_GridText",
    "label": "Grid Text"
   },
   {
    "code": "E:",
    "menu": "E",
    "key": ":",
    "symbol": "Edit_GridComp",
    "label": "Grid Comp"
   },
   {
    "code": "E!",
    "menu": "E",
    "key": "!",
    "symbol": "Edit_Pix_Mirror_X",
    "label": "Pix Mirror X"
   },
   {
    "code": "E.",
    "menu": "E",
    "key": ".",
    "symbol": "Edit_Pix_Convolution_Median",
    "label": "Pix Convolution Median"
   },
   {
    "code": "E\"",
    "menu": "E",
    "key": "\"",
    "symbol": "Edit_Pix_Mirror_Y",
    "label": "Pix Mirror Y"
   },
   {
    "code": "E*",
    "menu": "E",
    "key": "*",
    "symbol": "Edit_Spiral",
    "label": "Spiral"
   },
   {
    "code": "E/",
    "menu": "E",
    "key": "/",
    "symbol": "Edit_Pix_Convolution_UnDo",
    "label": "Pix Convolution Un Do"
   },
   {
    "code": "E#",
    "menu": "E",
    "key": "#",
    "symbol": "Edit_Pix_Rotate_CCW",
    "label": "Pix Rotate CCW"
   },
   {
    "code": "E%",
    "menu": "E",
    "key": "%",
    "symbol": "Edit_Pix_Rotate_USD",
    "label": "Pix Rotate USD"
   },
   {
    "code": "E<",
    "menu": "E",
    "key": "<",
    "symbol": "Edit_PadTrack",
    "label": "Pad Track"
   },
   {
    "code": "E=",
    "menu": "E",
    "key": "=",
    "symbol": "Edit_CentroidComp",
    "label": "Centroid Comp"
   },
   {
    "code": "E$",
    "menu": "E",
    "key": "$",
    "symbol": "Edit_Pix_Rotate_CW",
    "label": "Pix Rotate CW"
   },
   {
    "code": "E0",
    "menu": "E",
    "key": "0",
    "symbol": "Edit_Pix_Editor",
    "label": "Pix Editor"
   },
   {
    "code": "E1",
    "menu": "E",
    "key": "1",
    "symbol": "Edit_Pix_Trans_1",
    "label": "Pix Trans 1"
   },
   {
    "code": "E2",
    "menu": "E",
    "key": "2",
    "symbol": "Edit_Pix_Trans_2",
    "label": "Pix Trans 2"
   },
   {
    "code": "E3",
    "menu": "E",
    "key": "3",
    "symbol": "Edit_Pix_Trans_3",
    "label": "Pix Trans 3"
   },
   {
    "code": "E4",
    "menu": "E",
    "key": "4",
    "symbol": "Edit_Pix_Trans_4",
    "label": "Pix Trans 4"
   },
   {
    "code": "E6",
    "menu": "E",
    "key": "6",
    "symbol": "Edit_Pix_Crop",
    "label": "Pix Crop"
   },
   {
    "code": "E7",
    "menu": "E",
    "key": "7",
    "symbol": "Edit_Pix_Stackup",
    "label": "Pix Stackup"
   },
   {
    "code": "E9",
    "menu": "E",
    "key": "9",
    "symbol": "Edit_Pix_Rectangularization",
    "label": "Pix Rectangularization"
   },
   {
    "code": "Ea",
    "menu": "E",
    "key": "a",
    "symbol": "Edit_Align",
    "label": "Align"
   },
   {
    "code": "EA",
    "menu": "E",
    "key": "A",
    "symbol": "Edit_Arc",
    "label": "Arc"
   },
   {
    "code": "Eb",
    "menu": "E",
    "key": "b",
    "symbol": "Edit_Goto_Bot",
    "label": "Goto Bot"
   },
   {
    "code": "EB",
    "menu": "E",
    "key": "B",
    "symbol": "Edit_PasteClipboard",
    "label": "Paste Clipboard"
   },
   {
    "code": "Ec",
    "menu": "E",
    "key": "c",
    "symbol": "Edit_ReplaceConfirm",
    "label": "Replace Confirm"
   },
   {
    "code": "EC",
    "menu": "E",
    "key": "C",
    "symbol": "Edit_Components",
    "label": "Components"
   },
   {
    "code": "Ed",
    "menu": "E",
    "key": "d",
    "symbol": "Edit_ReplaceNext",
    "label": "Replace Next"
   },
   {
    "code": "ED",
    "menu": "E",
    "key": "D",
    "symbol": "Edit_QueryData",
    "label": "Query Data"
   },
   {
    "code": "Ee",
    "menu": "E",
    "key": "e",
    "symbol": "Edit_Goto_End",
    "label": "Goto End"
   },
   {
    "code": "EE",
    "menu": "E",
    "key": "E",
    "symbol": "Edit_QuerySequence",
    "label": "Query Sequence"
   },
   {
    "code": "Ef",
    "menu": "E",
    "key": "f",
    "symbol": "Edit_Find",
    "label": "Find"
   },
   {
    "code": "EF",
    "menu": "E",
    "key": "F",
    "symbol": "Edit_FilledSolid",
    "label": "Filled Solid"
   },
   {
    "code": "Eg",
    "menu": "E",
    "key": "g",
    "symbol": "Edit_Goto",
    "label": "Goto"
   },
   {
    "code": "EG",
    "menu": "E",
    "key": "G",
    "symbol": "Edit_Pix_ColorAlign",
    "label": "Pix Color Align"
   },
   {
    "code": "Eh",
    "menu": "E",
    "key": "h",
    "symbol": "Edit_Goto_Home",
    "label": "Goto Home"
   },
   {
    "code": "Ei",
    "menu": "E",
    "key": "i",
    "symbol": "Edit_HTML_Map",
    "label": "HTML Map"
   },
   {
    "code": "EK",
    "menu": "E",
    "key": "K",
    "symbol": "Edit_KrumpComponent",
    "label": "Krump Component"
   },
   {
    "code": "El",
    "menu": "E",
    "key": "l",
    "symbol": "Edit_Dbase_Column",
    "label": "Dbase Column"
   },
   {
    "code": "EL",
    "menu": "E",
    "key": "L",
    "symbol": "Edit_Line",
    "label": "Line"
   },
   {
    "code": "Em",
    "menu": "E",
    "key": "m",
    "symbol": "Edit_HTML_UnMap",
    "label": "HTML Un Map"
   },
   {
    "code": "EM",
    "menu": "E",
    "key": "M",
    "symbol": "Edit_ReseqComp",
    "label": "Reseq Comp"
   },
   {
    "code": "En",
    "menu": "E",
    "key": "n",
    "symbol": "Edit_FindNext",
    "label": "Find Next"
   },
   {
    "code": "EN",
    "menu": "E",
    "key": "N",
    "symbol": "Edit_Component",
    "label": "Component"
   },
   {
    "code": "Eo",
    "menu": "E",
    "key": "o",
    "symbol": "Edit_Dbase_Compact",
    "label": "Dbase Compact"
   },
   {
    "code": "EO",
    "menu": "E",
    "key": "O",
    "symbol": "Edit_LocateComponent",
    "label": "Locate Component"
   },
   {
    "code": "Ep",
    "menu": "E",
    "key": "p",
    "symbol": "Edit_Compare",
    "label": "Compare"
   },
   {
    "code": "EP",
    "menu": "E",
    "key": "P",
    "symbol": "Edit_Pad",
    "label": "Pad"
   },
   {
    "code": "EQ",
    "menu": "E",
    "key": "Q",
    "symbol": "Edit_QueryItems",
    "label": "Query Items"
   },
   {
    "code": "Er",
    "menu": "E",
    "key": "r",
    "symbol": "Edit_Replace",
    "label": "Replace"
   },
   {
    "code": "ES",
    "menu": "E",
    "key": "S",
    "symbol": "Edit_SnapItem",
    "label": "Snap Item"
   },
   {
    "code": "Et",
    "menu": "E",
    "key": "t",
    "symbol": "Edit_LinetoArc",
    "label": "Lineto Arc"
   },
   {
    "code": "ET",
    "menu": "E",
    "key": "T",
    "symbol": "Edit_TextString",
    "label": "Text String"
   },
   {
    "code": "EU",
    "menu": "E",
    "key": "U",
    "symbol": "Edit_QuickZoom",
    "label": "Quick Zoom"
   },
   {
    "code": "Ev",
    "menu": "E",
    "key": "v",
    "symbol": "Edit_GraphicsView",
    "label": "Graphics View"
   },
   {
    "code": "EV",
    "menu": "E",
    "key": "V",
    "symbol": "Edit_TextView",
    "label": "Text View"
   },
   {
    "code": "Ex",
    "menu": "E",
    "key": "x",
    "symbol": "Edit_ShellExecute",
    "label": "Shell Execute"
   },
   {
    "code": "EX",
    "menu": "E",
    "key": "X",
    "symbol": "Edit_TextParameters",
    "label": "Text Parameters"
   },
   {
    "code": "EY",
    "menu": "E",
    "key": "Y",
    "symbol": "Edit_CopyClipboard",
    "label": "Copy Clipboard"
   },
   {
    "code": "Ez",
    "menu": "E",
    "key": "z",
    "symbol": "Edit_Dbase_MultiColumn",
    "label": "Dbase Multi Column"
   },
   {
    "code": "EZ",
    "menu": "E",
    "key": "Z",
    "symbol": "Edit_Pix_Trapezoid",
    "label": "Pix Trapezoid"
   }
  ]
 },
 {
  "key": "D",
  "label": "Delete",
  "commands": [
   {
    "code": "DA",
    "menu": "D",
    "key": "A",
    "symbol": "Delete_Arc",
    "label": "Arc"
   },
   {
    "code": "DC",
    "menu": "D",
    "key": "C",
    "symbol": "Delete_Component",
    "label": "Component"
   },
   {
    "code": "DE",
    "menu": "D",
    "key": "E",
    "symbol": "Delete_Vertex",
    "label": "Vertex"
   },
   {
    "code": "DF",
    "menu": "D",
    "key": "F",
    "symbol": "Delete_FilledSolid",
    "label": "Filled Solid"
   },
   {
    "code": "DG",
    "menu": "D",
    "key": "G",
    "symbol": "Delete_GrabbedItems",
    "label": "Grabbed Items"
   },
   {
    "code": "DH",
    "menu": "D",
    "key": "H",
    "symbol": "Delete_HilightedItems",
    "label": "Hilighted Items"
   },
   {
    "code": "DI",
    "menu": "D",
    "key": "I",
    "symbol": "Delete_IsoIslands",
    "label": "Iso Islands"
   },
   {
    "code": "DL",
    "menu": "D",
    "key": "L",
    "symbol": "Delete_Line",
    "label": "Line"
   },
   {
    "code": "DM",
    "menu": "D",
    "key": "M",
    "symbol": "Delete_MultiLine",
    "label": "Multi Line"
   },
   {
    "code": "DO",
    "menu": "D",
    "key": "O",
    "symbol": "Delete_FloodLines",
    "label": "Flood Lines"
   },
   {
    "code": "DP",
    "menu": "D",
    "key": "P",
    "symbol": "Delete_Pad",
    "label": "Pad"
   },
   {
    "code": "DR",
    "menu": "D",
    "key": "R",
    "symbol": "Delete_TearDrops",
    "label": "Tear Drops"
   },
   {
    "code": "DT",
    "menu": "D",
    "key": "T",
    "symbol": "Delete_Text",
    "label": "Text"
   }
  ]
 },
 {
  "key": "U",
  "label": "Un-Do",
  "commands": [
   {
    "code": "UA",
    "menu": "U",
    "key": "A",
    "symbol": "UnDo_All",
    "label": "All"
   },
   {
    "code": "UE",
    "menu": "U",
    "key": "E",
    "symbol": "ReDo_All",
    "label": "All"
   },
   {
    "code": "UP",
    "menu": "U",
    "key": "P",
    "symbol": "ReDo_Purge",
    "label": "Purge"
   },
   {
    "code": "UR",
    "menu": "U",
    "key": "R",
    "symbol": "ReDo_Event",
    "label": "Event"
   },
   {
    "code": "US",
    "menu": "U",
    "key": "S",
    "symbol": "UnDo_Purge",
    "label": "Purge"
   },
   {
    "code": "UU",
    "menu": "U",
    "key": "U",
    "symbol": "UnDo_Event",
    "label": "Event"
   }
  ]
 },
 {
  "key": "S",
  "label": "Setup",
  "commands": [
   {
    "code": "SA",
    "menu": "S",
    "key": "A",
    "symbol": "Setup_Admin",
    "label": "Admin"
   },
   {
    "code": "Sc",
    "menu": "S",
    "key": "c",
    "symbol": "Setup_Library_AddDel",
    "label": "Library Add Del"
   },
   {
    "code": "SC",
    "menu": "S",
    "key": "C",
    "symbol": "Setup_Components",
    "label": "Components"
   },
   {
    "code": "SE",
    "menu": "S",
    "key": "E",
    "symbol": "Setup_Embroidery",
    "label": "Embroidery"
   },
   {
    "code": "SF",
    "menu": "S",
    "key": "F",
    "symbol": "Setup_Library_Files",
    "label": "Library Files"
   },
   {
    "code": "SG",
    "menu": "S",
    "key": "G",
    "symbol": "Setup_GridSnaps",
    "label": "Grid Snaps"
   },
   {
    "code": "SK",
    "menu": "S",
    "key": "K",
    "symbol": "Setup_KeyStrokeMacros",
    "label": "Key Stroke Macros"
   },
   {
    "code": "SL",
    "menu": "S",
    "key": "L",
    "symbol": "Setup_Layers",
    "label": "Layers"
   },
   {
    "code": "SM",
    "menu": "S",
    "key": "M",
    "symbol": "Setup_FileParameters",
    "label": "File Parameters"
   },
   {
    "code": "SO",
    "menu": "S",
    "key": "O",
    "symbol": "Setup_Options",
    "label": "Options"
   },
   {
    "code": "Sp",
    "menu": "S",
    "key": "p",
    "symbol": "Setup_PrinterFont",
    "label": "Printer Font"
   },
   {
    "code": "SP",
    "menu": "S",
    "key": "P",
    "symbol": "Setup_ZeroPoint",
    "label": "Zero Point"
   },
   {
    "code": "Ss",
    "menu": "S",
    "key": "s",
    "symbol": "Setup_ScreenFont",
    "label": "Screen Font"
   },
   {
    "code": "ST",
    "menu": "S",
    "key": "T",
    "symbol": "Setup_OrthoMode",
    "label": "Ortho Mode"
   },
   {
    "code": "SU",
    "menu": "S",
    "key": "U",
    "symbol": "Setup_Preferences",
    "label": "Preferences"
   },
   {
    "code": "Sw",
    "menu": "S",
    "key": "w",
    "symbol": "Setup_MouseWheel",
    "label": "Mouse Wheel"
   },
   {
    "code": "SW",
    "menu": "S",
    "key": "W",
    "symbol": "Setup_MirrorView",
    "label": "Mirror View"
   },
   {
    "code": "Sx",
    "menu": "S",
    "key": "x",
    "symbol": "Setup_ShellExecute",
    "label": "Shell Execute"
   }
  ]
 },
 {
  "key": "B",
  "label": "Block",
  "commands": [
   {
    "code": "Ba",
    "menu": "B",
    "key": "a",
    "symbol": "Block_all",
    "label": "all"
   },
   {
    "code": "BA",
    "menu": "B",
    "key": "A",
    "symbol": "Block_TearDrop",
    "label": "Tear Drop"
   },
   {
    "code": "Bb",
    "menu": "B",
    "key": "b",
    "symbol": "Block_byte",
    "label": "byte"
   },
   {
    "code": "BB",
    "menu": "B",
    "key": "B",
    "symbol": "Block_BuildComponent",
    "label": "Build Component"
   },
   {
    "code": "Bc",
    "menu": "B",
    "key": "c",
    "symbol": "Block_column",
    "label": "column"
   },
   {
    "code": "BC",
    "menu": "B",
    "key": "C",
    "symbol": "Block_Copy",
    "label": "Copy"
   },
   {
    "code": "BD",
    "menu": "B",
    "key": "D",
    "symbol": "Block_Delete",
    "label": "Delete"
   },
   {
    "code": "Be",
    "menu": "B",
    "key": "e",
    "symbol": "Block_paste",
    "label": "paste"
   },
   {
    "code": "BE",
    "menu": "B",
    "key": "E",
    "symbol": "Block_Release",
    "label": "Release"
   },
   {
    "code": "BF",
    "menu": "B",
    "key": "F",
    "symbol": "Block_FloodFill",
    "label": "Flood Fill"
   },
   {
    "code": "Bg",
    "menu": "B",
    "key": "g",
    "symbol": "Block_group",
    "label": "group"
   },
   {
    "code": "BG",
    "menu": "B",
    "key": "G",
    "symbol": "Block_Rectangle",
    "label": "Rectangle"
   },
   {
    "code": "BI",
    "menu": "B",
    "key": "I",
    "symbol": "Block_Polyline",
    "label": "Polyline"
   },
   {
    "code": "Bl",
    "menu": "B",
    "key": "l",
    "symbol": "Block_line",
    "label": "line"
   },
   {
    "code": "BL",
    "menu": "B",
    "key": "L",
    "symbol": "Block_Layers",
    "label": "Layers"
   },
   {
    "code": "BM",
    "menu": "B",
    "key": "M",
    "symbol": "Block_Move",
    "label": "Move"
   },
   {
    "code": "BN",
    "menu": "B",
    "key": "N",
    "symbol": "Block_NestComponent",
    "label": "Nest Component"
   },
   {
    "code": "BO",
    "menu": "B",
    "key": "O",
    "symbol": "Block_IsolationOutput",
    "label": "Isolation Output"
   },
   {
    "code": "Bp",
    "menu": "B",
    "key": "p",
    "symbol": "Block_pointplot",
    "label": "pointplot"
   },
   {
    "code": "BP",
    "menu": "B",
    "key": "P",
    "symbol": "Block_PasteClipboard",
    "label": "Paste Clipboard"
   },
   {
    "code": "BQ",
    "menu": "B",
    "key": "Q",
    "symbol": "Block_IsolationSequence",
    "label": "Isolation Sequence"
   },
   {
    "code": "BR",
    "menu": "B",
    "key": "R",
    "symbol": "Block_Rotate",
    "label": "Rotate"
   },
   {
    "code": "Bs",
    "menu": "B",
    "key": "s",
    "symbol": "Block_sort",
    "label": "sort"
   },
   {
    "code": "BS",
    "menu": "B",
    "key": "S",
    "symbol": "Block_Delete_Outside",
    "label": "Delete Outside"
   },
   {
    "code": "Bt",
    "menu": "B",
    "key": "t",
    "symbol": "Block_cut",
    "label": "cut"
   },
   {
    "code": "BT",
    "menu": "B",
    "key": "T",
    "symbol": "Block_TrackIsolation",
    "label": "Track Isolation"
   },
   {
    "code": "By",
    "menu": "B",
    "key": "y",
    "symbol": "Block_copy",
    "label": "copy"
   },
   {
    "code": "BY",
    "menu": "B",
    "key": "Y",
    "symbol": "Block_CopyClipboard",
    "label": "Copy Clipboard"
   }
  ]
 },
 {
  "key": "N",
  "label": "Nets",
  "commands": [
   {
    "code": "N-",
    "menu": "N",
    "key": "-",
    "symbol": "Nets_NetScanMinus",
    "label": "Net Scan Minus"
   },
   {
    "code": "N+",
    "menu": "N",
    "key": "+",
    "symbol": "Nets_NetScanPlus",
    "label": "Net Scan Plus"
   },
   {
    "code": "NA",
    "menu": "N",
    "key": "A",
    "symbol": "Nets_AutoRoute",
    "label": "Auto Route"
   },
   {
    "code": "NC",
    "menu": "N",
    "key": "C",
    "symbol": "Nets_ClearHilight",
    "label": "Clear Highlights"
   },
   {
    "code": "NG",
    "menu": "N",
    "key": "G",
    "symbol": "Nets_NetScanLog",
    "label": "Net Scan Log"
   },
   {
    "code": "NH",
    "menu": "N",
    "key": "H",
    "symbol": "Nets_HilightNet",
    "label": "Highlight Net"
   },
   {
    "code": "NI",
    "menu": "N",
    "key": "I",
    "symbol": "Nets_NetListIn",
    "label": "Net List In"
   },
   {
    "code": "NL",
    "menu": "N",
    "key": "L",
    "symbol": "Nets_RatLine",
    "label": "Rat Line"
   },
   {
    "code": "NM",
    "menu": "N",
    "key": "M",
    "symbol": "Nets_Image",
    "label": "Image"
   },
   {
    "code": "NN",
    "menu": "N",
    "key": "N",
    "symbol": "Nets_NameNet",
    "label": "Name Net"
   },
   {
    "code": "NO",
    "menu": "N",
    "key": "O",
    "symbol": "Nets_NetListOut",
    "label": "Net List Out"
   },
   {
    "code": "NR",
    "menu": "N",
    "key": "R",
    "symbol": "Nets_RatNest",
    "label": "Ratsnest"
   },
   {
    "code": "NS",
    "menu": "N",
    "key": "S",
    "symbol": "Nets_NetScan",
    "label": "Net Scan"
   },
   {
    "code": "NT",
    "menu": "N",
    "key": "T",
    "symbol": "Nets_RatNestLite",
    "label": "Ratsnest (lite)"
   },
   {
    "code": "NU",
    "menu": "N",
    "key": "U",
    "symbol": "Nets_UnRatNest",
    "label": "Un-Ratsnest"
   }
  ]
 },
 {
  "key": "Z",
  "label": "Zoom",
  "commands": [
   {
    "code": "Z)",
    "menu": "Z",
    "key": ")",
    "symbol": "Zoom_IN",
    "label": "IN"
   },
   {
    "code": "Z/",
    "menu": "Z",
    "key": "/",
    "symbol": "Zoom_OUT",
    "label": "OUT"
   },
   {
    "code": "ZA",
    "menu": "Z",
    "key": "A",
    "symbol": "Zoom_Absolute",
    "label": "Absolute"
   },
   {
    "code": "ZB",
    "menu": "Z",
    "key": "B",
    "symbol": "Zoom_Board",
    "label": "Board"
   },
   {
    "code": "ZC",
    "menu": "Z",
    "key": "C",
    "symbol": "Zoom_Center",
    "label": "Center"
   },
   {
    "code": "Zi",
    "menu": "Z",
    "key": "i",
    "symbol": "Zoom_in",
    "label": "in"
   },
   {
    "code": "ZI",
    "menu": "Z",
    "key": "I",
    "symbol": "Zoom_In",
    "label": "In"
   },
   {
    "code": "ZK",
    "menu": "Z",
    "key": "K",
    "symbol": "Zoom_Block",
    "label": "Block"
   },
   {
    "code": "ZL",
    "menu": "Z",
    "key": "L",
    "symbol": "Zoom_Layer",
    "label": "Layer"
   },
   {
    "code": "ZM",
    "menu": "Z",
    "key": "M",
    "symbol": "Zoom_Limits",
    "label": "Limits"
   },
   {
    "code": "Zo",
    "menu": "Z",
    "key": "o",
    "symbol": "Zoom_out",
    "label": "out"
   },
   {
    "code": "ZO",
    "menu": "Z",
    "key": "O",
    "symbol": "Zoom_Out",
    "label": "Out"
   },
   {
    "code": "ZR",
    "menu": "Z",
    "key": "R",
    "symbol": "Zoom_Redraw",
    "label": "Redraw"
   },
   {
    "code": "Zs",
    "menu": "Z",
    "key": "s",
    "symbol": "Zoom_save",
    "label": "save"
   },
   {
    "code": "ZS",
    "menu": "Z",
    "key": "S",
    "symbol": "Zoom_Scale",
    "label": "Scale"
   },
   {
    "code": "ZW",
    "menu": "Z",
    "key": "W",
    "symbol": "Zoom_Window",
    "label": "Window"
   },
   {
    "code": "ZX",
    "menu": "Z",
    "key": "X",
    "symbol": "Zoom_Extents",
    "label": "Extents"
   },
   {
    "code": "ZY",
    "menu": "Z",
    "key": "Y",
    "symbol": "Zoom_Only",
    "label": "Only"
   }
  ]
 },
 {
  "key": "?",
  "label": "Help",
  "commands": [
   {
    "code": "?A",
    "menu": "?",
    "key": "A",
    "symbol": "Help_About",
    "label": "About"
   },
   {
    "code": "?F",
    "menu": "?",
    "key": "F",
    "symbol": "Help_Features",
    "label": "Features"
   },
   {
    "code": "?H",
    "menu": "?",
    "key": "H",
    "symbol": "Help_Help",
    "label": "Help"
   },
   {
    "code": "?M",
    "menu": "?",
    "key": "M",
    "symbol": "Help_Manual",
    "label": "Manual"
   },
   {
    "code": "?O",
    "menu": "?",
    "key": "O",
    "symbol": "Help_OverView",
    "label": "Over View"
   },
   {
    "code": "?P",
    "menu": "?",
    "key": "P",
    "symbol": "Help_Tips",
    "label": "Tips"
   },
   {
    "code": "?R",
    "menu": "?",
    "key": "R",
    "symbol": "Help_Support",
    "label": "Support"
   },
   {
    "code": "?S",
    "menu": "?",
    "key": "S",
    "symbol": "Help_Path",
    "label": "Path"
   },
   {
    "code": "?T",
    "menu": "?",
    "key": "T",
    "symbol": "Help_HowTo",
    "label": "How To"
   },
   {
    "code": "?U",
    "menu": "?",
    "key": "U",
    "symbol": "Help_Updates",
    "label": "Updates"
   },
   {
    "code": "?W",
    "menu": "?",
    "key": "W",
    "symbol": "Help_Website",
    "label": "Website"
   }
  ]
 }
];

/** Every command, indexed by its two-key code. */
export const COMMANDS_BY_CODE: ReadonlyMap<string, MenuCommand> = new Map(
  MENUS.flatMap((m) => m.commands.map((c) => [c.code, c] as const)),
);
